import script from "./BannerMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerMessage.vue?vue&type=script&setup=true&lang=js"

import "./BannerMessage.vue?vue&type=style&index=0&id=5044a421&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5044a421"]])

export default __exports__